export const customerIdSelector = (state) => state.user.currentCompany;
